// extracted by mini-css-extract-plugin
export default {"avatar":"UserInfo_avatar__uHI-2"};